import { useTheme } from "@mui/material"

function useStyles() {
    const { breakpoints } = useTheme()
    return {
        container: {
            width: '100%',
            height: '100%',
            backgroundColor: 'white',
            padding: 3,
            margin: '0px',
            position: 'relative',
            '& .flex': { display: 'flex'},
            '& .flex2': { display: 'flex', height:'100%' },
            '& .flex-col': { flexDirection: 'column' },
            '& .item-center': { itemsCenter: 'center' },
            '& .align-center': { alignItems: 'center' },
            '& .justify-end': { justifyContent: 'end' },
            '& .justify-space': { justifyContent: ' space-between' },
            '& .gap-2': { gap: 2 },
            '& .w-full': { width: '100%' },
            '& .pb-30': { paddingBottom: '50px' },
            '& .mt-30': { marginTop: '30px' },
            '& .wrap': { flexWrap: 'wrap' },
            '& .column': { 
                [breakpoints.down(1615)]: {
                    width: '100%'
                  }, 
            }
        },
        footer: {
            position: 'absolute',
            bottom: '20px',
            right: '20px'
        },
        mainContainer: {
            display: 'flex', 
            flexDirection: 'column', 
            height: '100%', 
        },
        butonWidth: (evidences:boolean) => ({
            ...evidences && {
                width:'100%'
            }
        })
    }
}

export { useStyles }